import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 1h10v1.25L6.5 5H2v2h2v2H2v2h2v4H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m6 8 5-4 5 4v7h-4v-4h-2v4H6z"
	})]
});
export default SvgHouseBuilding;
